import { useState, useRef, useEffect } from "react";
import { close } from "helper/icons";

export const WaitlistDropdown = ({
  placeholder = "Add from Waitlist",
  width = "w-[220px]",
  dropdownOptions = [],
  onAddDog,
  disabled = false,
  loading = false,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isShowMenu, setIsShowMenu] = useState(false);
  const [filterDropdownOptions, setFilterDropdownOptions] = useState([]);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setFilterDropdownOptions(dropdownOptions);
  }, [dropdownOptions]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value.trim() === "") {
      setFilterDropdownOptions(dropdownOptions);
    } else {
      const filtered = dropdownOptions.filter((option) =>
        option.displayText.toLowerCase().includes(value.toLowerCase())
      );
      setFilterDropdownOptions(filtered);
    }
  };

  const handleClearRequest = () => {
    setSearchTerm("");
    setFilterDropdownOptions(dropdownOptions);
  };

  const handleAddClick = (e, dog) => {
    e.stopPropagation();
    onAddDog(dog);
    setSearchTerm("");
    setFilterDropdownOptions(dropdownOptions);
    setIsShowMenu(false);
  };

  return (
    <div className={`relative ${width}`} ref={dropdownRef}>
      <div className="flex flex-row gap-2 flex-1 items-stretch relative">
        <div className="flex row flex-1 flex-grow relative w-full">
          <input
            autoComplete="off"
            placeholder={placeholder}
            value={searchTerm}
            className={`h-auto w-full rounded-md border border-gray-300 shadow-md py-2.5 pl-3.5 pr-10 ${
              disabled ? "text-gray-900/50" : "text-gray-900"
            } font-inter font-normal text-base inputFocus focus:outline-none bg-white`}
            onChange={handleInputChange}
            onFocus={() => setIsShowMenu(true)}
            disabled={disabled || loading}
          />
          {searchTerm && !disabled && !loading ? (
            <img
              onClick={handleClearRequest}
              src={close}
              alt=""
              height={20}
              width={20}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
            />
          ) : null}
        </div>

        {isShowMenu && filterDropdownOptions.length > 0 && (
          <div
            className={`origin-top-left absolute left-0 top-10 mt-2 rounded-md border-2 border-gray-400 bg-white ${width} z-50 max-h-80 overflow-auto`}
            style={{ boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)' }}
          >
            <div className="py-1" role="menu" aria-orientation="vertical">
              {filterDropdownOptions.map((option, index) => (
                <div
                  key={option.id}
                  className={`flex items-center justify-between px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 ${
                    index !== filterDropdownOptions.length - 1
                      ? "border-b border-gray-200"
                      : ""
                  }`}
                  role="menuitem"
                >
                  <span className="flex-1 text-left pr-2">
                    {option.displayText}
                  </span>
                  <button
                    onClick={(e) => handleAddClick(e, option)}
                    className="flex-shrink-0 w-6 h-6 rounded-full bg-primary hover:bg-primary-dark text-white flex items-center justify-center transition-colors"
                    title="Add to draw"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 4v16m8-8H4"
                      />
                    </svg>
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

